module.exports = __webpack_public_path__ + "img/wedo1.c76d6f7a.png";